<template>
  <div id="feedforwardMain">
    <feedforwardSurvey
      v-if="leader && !error && !confirmation"
      :leader="leader"
      :error.sync="error"
      :error-text.sync="errorText"
      :confirmation.sync="confirmation"
      :dialog-width="dialogWidth"
      :dialog-padding="dialogPadding"
    />
    <feedforwardError
      v-else-if="error"
      :error-text="errorText"
      :dialog-width="dialogWidth"
    />
    <feedforwardConfirmation
      v-else-if="confirmation"
      :dialog-width="dialogWidth"
      :dialog-padding="dialogPadding"
    />

    <Footer style="width: 100%; position: fixed; bottom: 0;" />
  </div>
</template>

<script>
import api from '@/api';
import DialogSetting from '@/mixins/dialog';
import Footer from '@/views/dashboard/layout/Footer.vue';
import feedforwardSurvey from './FeedforwardSurvey.vue';
import feedforwardError from './FeedforwardError.vue';
import feedforwardConfirmation from './FeedforwardConfirmation.vue';

export default {
  components: {
    feedforwardSurvey,
    feedforwardError,
    feedforwardConfirmation,
    Footer,
  },

  mixins: [DialogSetting],

  data() {
    return {
      error: false,
      errorText: this.$t('coworker.feedforward.alreadySubmitted'),
      confirmation: false,
      leader: null,
    };
  },

  created() {
    this.fetchLeaderData();
  },

  methods: {
    async fetchLeaderData() {
      try {
        const response = await api.getLeaderData(this.$route.params.id);
        this.leader = response.data;
      } catch (err) {
        if (err.msg) {
          this.errorText = err.msg;
        }
        this.error = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#feedforwardMain {
  min-height: 100vh;
  padding: 20px 5px 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background: #003a70;
}
</style>
